import { useState } from 'react'
import { useTranslation } from 'react-i18next'
import { ANIMAL_TYPES, COLORS } from '../lib/constants'

interface Props {
  open: boolean
  onClose: () => void
}

export function AddSightingModal({ open, onClose }: Props) {
  const { t } = useTranslation()
  const [type, setType] = useState('dog')
  const [color1, setColor1] = useState('brown_chocolate')
  const [color2, setColor2] = useState('')
  const [chip, setChip] = useState('')

  if (!open) return null

  return (
    <div className="modal-backdrop" role="presentation" onClick={onClose}>
      <div
        className="modal"
        role="dialog"
        aria-modal="true"
        aria-labelledby="add-sighting-title"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 id="add-sighting-title">{t('forms.addSightingTitle')}</h2>
        <form
          className="form-grid"
          onSubmit={(e) => {
            e.preventDefault()
            // API wiring in next iteration
            onClose()
          }}
        >
          <div className="field">
            <label htmlFor="type">{t('fields.type')}</label>
            <select id="type" value={type} onChange={(e) => setType(e.target.value)}>
              {ANIMAL_TYPES.map((key) => (
                <option key={key} value={key}>
                  {t(`types.${key}`)}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label htmlFor="color1">{t('fields.color1')}</label>
            <select id="color1" value={color1} onChange={(e) => setColor1(e.target.value)}>
              {COLORS.map((key) => (
                <option key={key} value={key}>
                  {t(`colors.${key}`)}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label htmlFor="color2">{t('fields.color2')}</label>
            <select id="color2" value={color2} onChange={(e) => setColor2(e.target.value)}>
              <option value="">{t('fields.none')}</option>
              {COLORS.map((key) => (
                <option key={key} value={key}>
                  {t(`colors.${key}`)}
                </option>
              ))}
            </select>
          </div>
          <div className="field">
            <label htmlFor="chip">{t('fields.chip')}</label>
            <input
              id="chip"
              value={chip}
              onChange={(e) => setChip(e.target.value)}
              placeholder={t('forms.chipPlaceholder')}
            />
          </div>
          <p className="empty-state">{t('actions.pickOnMap')} — map pick wiring next.</p>
          <div className="form-actions">
            <button type="button" className="btn" onClick={onClose}>
              {t('actions.cancel')}
            </button>
            <button type="submit" className="btn btn-primary">
              {t('actions.submit')}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}
